import React, { useEffect } from 'react'
import { Col, Form, Row } from 'react-bootstrap';
import { useForm } from 'react-hook-form'
import CustomButton from '../shared/CustomButton';
import { FaSave } from 'react-icons/fa';

const CityForm = ({
    city,
    isSaving,
    formAction
}) => {
    const {
        register,
        handleSubmit,
        reset,
        formState : {errors},
        setError
    } = useForm({defaultValues: city ? 
        {
            id: city.id,
            name: city.name
        } : {}
    });

    useEffect(() => {
        if (city) {
            reset({
                id: city.id,
                name: city.name
            });
        } else {
            reset({
                id: '',
                name: ''
            });
        }
    }, [reset, city]);

    const resetForm = () => {
        reset({
            id: '',
            name: ''
        });
    }

    const onSubmit = async (data) => {
        try {
            const success = await formAction(data);
            if (success) {
                resetForm();
            }
        } catch (error) {
            if (error.response && error.response.status === 422){
                Object.keys(error.response.data.errors).forEach((field) => {
                    setError(field, {
                        type: 'manual',
                        message: error.response.data.errors[field][0]
                    });
                });
            } else {
                throw error; // error to be handled by saveCity method in Cities.jsx
            }
        }
    }
  return (
    <Form onSubmit={handleSubmit(onSubmit)}>

        <Row>

            <Col xl={3} lg={4} md={6} sm={12}>

                <Form.Group>

                    <Form.Label htmlFor='name'>Name</Form.Label>
                    <input type='text' placeholder='Name' autoComplete='off' autoFocus
                        className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                        {...register('name', {
                            required: 'Enter city\'s name'
                        })}
                    />
                    {errors.name && (
                        <div className="invalid-feedback">{errors.name.message}</div>
                    )}
                </Form.Group>
            
            </Col>

        </Row>

        <CustomButton
            isSaving={isSaving}
            title={isSaving ? 'Saving' : 'Save'}
            icon={<FaSave />}
        />

    </Form>
  )
}

export default CityForm